import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { MotionConfig } from 'motion/react'
import {
    Bricolage_Grotesque,
    Inter_Tight,
    Instrument_Serif,
    JetBrains_Mono
} from 'next/font/google'
import { SmoothScroll } from '@/components/generals/smooth-scroll'
import { PageTransition } from '@/components/generals/page-transition'
import { Cursor } from '@/components/generals/cursor'

const sans = Inter_Tight({
    subsets: ['latin']
})

const mono = JetBrains_Mono({
    subsets: ['latin']
})

const heading = Bricolage_Grotesque({
    subsets: ['latin'],
    axes: ['opsz', 'wdth']
})

const serif = Instrument_Serif({
    subsets: ['latin'],
    weight: '400',
    style: ['normal', 'italic']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily};--font-app-serif:${serif.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <MotionConfig reducedMotion='user'>
                <SmoothScroll>
                    <PageTransition>
                        <Component {...pageProps} />
                    </PageTransition>

                    <Cursor />
                </SmoothScroll>
            </MotionConfig>
        </div>
    )
}

export default App
